// ENBD (Emirates NBD) — conventional Visa, column layout (label on top, value
// directly below, aligned by x). Page-1 box has limit/available/dates/min; the
// "Total Payment Due" lives in the STATEMENT SUMMARY on a later page. The Noon
// Credits summary is loyalty points (not Floosi's) → ignored.
import { toNum, dmyToISO, rows, fieldBelow, pageWith, amountWithSign } from '../util.js';

export function parseENBD(pages) {
  const p1 = pages[0] || [];
  const sumPage = pageWith(pages, 'Total Payment Due') || p1;

  const summary = {
    statementDate: dmyToISO(fieldBelow(p1, 'Statement Date', { want: /\d{2}[/-]\d{2}/ })),
    dueDate: dmyToISO(fieldBelow(p1, 'Payment Due Date', { want: /\d{2}[/-]\d{2}/ })),
    minimumPayment: toNum(fieldBelow(p1, 'Minimum Payment Due')),
    creditLimit: toNum(fieldBelow(p1, 'Credit Limit')),
    availableLimit: toNum(fieldBelow(p1, 'Available Credit Limit')),
    closingBalance: toNum(fieldBelow(sumPage, 'Total Payment Due')),
    // ENBD labels the opening figure "Previous Statement Due", not "Previous Balance".
    previousBalance: toNum(fieldBelow(sumPage, 'Previous Statement')) ?? toNum(fieldBelow(p1, 'Previous Statement')),
  };

  const txns = [];
  for (const page of pages) {
    for (const { y, cells } of rows(page)) {
      const first = cells[0];
      if (!first || first.x > 70 || !/^\d{2}[/-]\d{2}[/-]\d{4}$/.test(first.s)) continue;
      // CR (credit) amounts render ~3px below the date row, landing in an
      // adjacent y-band — so fall back to searching the page near this row's y,
      // else every payment/refund silently drops.
      let amountCell = [...cells].reverse().find((c) => c.x > 480 && /^[\d,]+\.\d{2}/.test(c.s));
      if (!amountCell) amountCell = page.filter((c) => Math.abs(c.y - y) <= 5 && c.x > 480 && /^[\d,]+\.\d{2}/.test(c.s)).sort((a, b) => a.x - b.x).pop();
      if (!amountCell) continue;
      const posting = cells[1] && /^\d{2}[/-]\d{2}[/-]\d{4}$/.test(cells[1].s) ? cells[1].s : null;
      const mid = cells.filter((c) => c.x > 180 && c !== amountCell && c !== first && c !== (posting ? cells[1] : null));
      const desc = mid.map((c) => c.s).join(' ').replace(/\s{2,}/g, ' ').trim();
      const { amount, credit } = amountWithSign(amountCell.s);
      if (amount == null || !desc) continue;
      const tag = /INSTALLMENT PLAN EMI/i.test(desc) ? 'installment' : null;
      txns.push({ date: dmyToISO(first.s), postingDate: posting ? dmyToISO(posting) : null, description: desc, amount, credit, originalAmount: null, tag });
    }
  }

  return { bank: 'ENBD', summary, transactions: txns };
}
